module.exports = __webpack_public_path__ + "img/admin.12f5a195.png";